'use client';
import React from 'react';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-[90vh] flex items-center justify-start overflow-hidden"
      style={{
        backgroundImage: `url('https://timberpointcapital.com/assets/images/aerial_with_road_winding_thru_shutterstock_resized-1776306582656.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Gradient overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to right, rgba(15,34,64,0.92) 0%, rgba(15,34,64,0.75) 50%, rgba(0,0,0,0.2) 100%)',
        }}
      />
      {/* Bottom fade */}
      <div
        className="absolute bottom-0 left-0 right-0 h-32"
        style={{ background: 'linear-gradient(to top, #0f2240, transparent)' }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-32">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-8 h-0.5" style={{ backgroundColor: '#c9a84c' }} />
          <span
            className="text-xs font-semibold tracking-widest uppercase"
            style={{ color: '#c9a84c', letterSpacing: '0.2em' }}
          >
            Alternative Investment Solutions
          </span>
        </div>

        {/* Headline */}
        <h1 className="mb-6" style={{ fontFamily: 'Lato, sans-serif' }}>
          <span
            className="block font-black leading-tight"
            style={{ color: '#ffffff', fontSize: 'clamp(2.5rem, 6vw, 4.5rem)' }}
          >
            Institutional Rigor.
          </span>
          <span
            className="block font-black leading-tight"
            style={{ color: '#c9a84c', fontSize: 'clamp(2.5rem, 6vw, 4.5rem)' }}
          >
            Alternative
          </span>
          <span
            className="block font-black leading-tight"
            style={{ color: '#c9a84c', fontSize: 'clamp(2.5rem, 6vw, 4.5rem)' }}
          >
            Advantage.
          </span>
        </h1>

        {/* Subheadline */}
        <p
          className="mb-10 max-w-xl text-lg font-light"
          style={{ color: 'rgba(255,255,255,0.85)', lineHeight: '1.7' }}
        >
          Institutional-grade alternative investment access for independent financial advisors — powered by Fortis Capital Advisors.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap gap-4">
          <button
            onClick={() => scrollTo('why-alts')}
            className="px-8 py-4 text-sm font-semibold text-white transition-all duration-200 hover:opacity-90"
            style={{ backgroundColor: '#4060a1', fontFamily: 'Lato, sans-serif' }}
          >
            Explore Why Alternatives
          </button>
          <button
            onClick={() => scrollTo('contact')}
            className="px-8 py-4 text-sm font-semibold text-white transition-all duration-200 hover:bg-white hover:text-[#0f2240]"
            style={{ border: '2px solid #ffffff', backgroundColor: 'transparent', fontFamily: 'Lato, sans-serif' }}
          >
            Schedule a Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
